var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurrentAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 29.7,
    y1: 255.1,
    x2: 269.7,
    y2: 255.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 29.9,
    y1: 74.9,
    x2: 269.9,
    y2: 74.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M11.9,236.9c0,9.9,8,18,18,18"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 11.9,
    y1: 236.9,
    x2: 11.9,
    y2: 92.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 287.9,
    y1: 236.9,
    x2: 287.9,
    y2: 92.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M269.9,255.1c10.1,0,18.2-8.1,18.2-18.2"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 65.9,
    y1: 218.9,
    x2: 233.9,
    y2: 218.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 65.9,
    y1: 146.9,
    x2: 233.9,
    y2: 146.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M47.9,200.9c0,10,8,18,18,18"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 47.7,
    y1: 200.9,
    x2: 47.7,
    y2: 164.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    x1: 252.1,
    y1: 200.9,
    x2: 252.1,
    y2: 164.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M234.1,218.9c10.1,0,18.2-8.1,18.2-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M11.9,92.9c0-9.9,8-18,18-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M287.7,92.9c0-9.9-8.1-18-18-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M47.9,164.9c0-9.9,8-18,18-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M252.3,165.1c0-10-8.1-18-18-18"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 83.9,
    y1: 44.9,
    x2: 83.9,
    y2: 92.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 215.9,
    y1: 44.9,
    x2: 215.9,
    y2: 92.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 53.9,
    y1: 122.9,
    x2: 245.9,
    y2: 122.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrentAccount);
export default __webpack_public_path__ + "static/media/Icon_Current_Account.6bcabf975a8638936a67c05c0a3621ee.svg";
export { ForwardRef as ReactComponent };